export const makeBlockId = (key: string): string => `formBlock-${key}`;
